export class Pagination<T> {
  constructor(
    public result: T[],
    public pageIndex: number,
    public pageSize: number,
    public totalCount: number
  ) {}
}
